import React, { ReactNode } from "react";
import styled, { keyframes } from "styled-components";
import { Radius, Spacing, Transition, background } from "@glossy";
import * as HoverCard from "@radix-ui/react-hover-card";

interface IProps {
  trigger: ReactNode;
  content: ReactNode;
}

const slideUpAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(2px)" },
  "100%": { opacity: 1, transform: "translateY(0)" },
});

const slideRightAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateX(-2px)" },
  "100%": { opacity: 1, transform: "translateX(0)" },
});

const slideDownAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(-2px)" },
  "100%": { opacity: 1, transform: "translateY(0)" },
});

const slideLeftAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateX(2px)" },
  "100%": { opacity: 1, transform: "translateX(0)" },
});

const Trigger = styled(HoverCard.Trigger)`
  :hover {
    text-decoration: none;
  }
`;

const Content = styled(HoverCard.Content)`
  padding: ${Spacing.Medium};
  width: 300px;
  background-color: ${background};
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: ${Radius.MediumLarge};

  @media (prefers-reduced-motion: no-preference) {
    animation-duration: ${Transition.Length};
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    animation-fill-mode: forwards;
    willchange: transform, opacity;

    &[data-state="open"] {
      &[data-side="top"] {
        animation-name: ${slideDownAndFade};
      }
      &[data-side="right"] {
        animation-name: ${slideLeftAndFade};
      }
      &[data-side="bottom"] {
        animation-name: ${slideUpAndFade};
      }
      &[data-side="left"] {
        animation-name: ${slideRightAndFade};
      }
    }
  }
`;

const Arrow = styled(HoverCard.Arrow)`
  fill: ${background};
`;

const UiKitHoverCard = ({ trigger, content }: IProps) => (
  <HoverCard.Root openDelay={0} closeDelay={0}>
    <Trigger>{trigger}</Trigger>
    <Content>
      {content}
      <Arrow offset={24} />
    </Content>
  </HoverCard.Root>
);

export default UiKitHoverCard;
